<template>
  <div v-if="!isPortrait">
    <!-- PC端浮动留资 mob端右侧按钮浮动 -->
    <div class="oneform" :class="{ 'animate': isAnimating }">
        <el-form :inline="true">

          <el-form-item class="inbox">
            <el-select class="inboxinput" v-model="formInline.CarSeriesCMSID" placeholder="请选择车型" @change="setCarSeries">
              <el-option v-for="(item, key) in (carAlldata ? carAlldata.series : [])" :key="key" :value="item.cmsid"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="inbox">
            <el-select class="inboxinput" v-model="formInline.Province" placeholder="选择省份" @change="setProvince">
              <el-option v-for="(item, key) in (alldata ? alldata.province : [])" :value="item.id" :key="key"
                :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="inbox">
            <el-select class="inboxinput" v-model="formInline.City" placeholder="选择城市" @click="setCity()"
              code-stm="event, PAGEURL, 切换城市信息pc" @change="cityChange">
              <el-option v-for="(item, key) in this.cascadingCities" :value="item.id" :key="key" :label="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="inbox">

              <!-- <el-select class="inboxinput" v-model="formInline.DealerCode" placeholder="经销商" @change="dealerChange">
                <el-option v-for="(item, key) in this.cascadingDealers" :key="key" :value="item.code"
                  :label="item.name"></el-option>
              </el-select> -->
              <el-select
                class="inboxinput"
                v-model="formInline.DealerCode"
                placeholder="请选择经销商"
                @change="dealerChange"
                popper-class="select-option-dealer"
              >
                <el-option
                  v-for="(item, key) in this.cascadingDealers"
                  :key="key"
                  :value="item.code"
                  :label="item.name"
                  :disabled="item.isDisabled"
                >
                <template #default>
                  <div  style="display: flex;align-items: start;padding: 5px 0;">
                    <i v-if="formInline.DealerCode == item.code" class="el-icon-check" style="padding-top: 10px;font-weight: 700;"></i>
                    <div v-else style="width: 14px;height: 14px;"></div>
                    <div style="padding-left: 10px;" >
                      <div>{{ item.name }}</div>
                      <div style="color: rgba(180, 183, 192, 1);font-size: 12px;line-height: 20px;">{{ item.address }}</div>
                    </div>
                  </div>
                </template>
              </el-option>
              </el-select>
          </el-form-item>
                    <el-form-item class="inbox">
            <el-input class="inboxinput" v-model="formInline.Name" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item class="inbox">
            <el-input class="inboxinput" v-model="formInline.Phone" placeholder="电话"></el-input>
          </el-form-item>
          <el-form-item  class="inbox">
            <el-input
              placeholder="验证码"
              class="inboxinput"
              v-model="formInline.verificationCode"
              maxlength="6"
              oninput="if(value.length > 6) value=value.slice(0, 6)">
              <template slot="append">
                <el-button
                  class="button"
                  id="captcha-button-bottom"
                  code-stm="event, PAGEURL, 获取验证码mob"
                  :class="{ disabled: !this.countDownCanClick }"
                  :disabled="!this.countDownCanClick"
                  style="padding:0 3px;width:calc(90 / 1920 * 100vw);height:40px;font-size:calc(14 / 1920 * 100vw);background: #fff;border-radius: 0;border-top: 1px solid #DDDFE5;border-bottom: 1px solid #DDDFE5;color:#000"
                  @click="handleCaptchaButtonClick('main')"
                  >{{ countDownContent }}
                </el-button>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item style="margin-bottom: auto !important;">
            <el-checkbox v-model="formInline.checked" className="agreement-checkbox" @change="checkboxChange"
            style="display: flex;justify-content: center;align-items: center;">
              <!-- <span class="tips">
                我同意起亚及合作商就购买新车<br />事宜与我联系我同意提供电话号码
              </span> -->
              <span class="tips" style="color: #05141F99;white-space: nowrap;">
              已阅读并同意
              <span  style="text-decoration: underline;color: #05141F;white-space: nowrap;" @click="read" code-stm="event, PAGEURL, 隐私协议">
                《隐私协议》
              </span>，
              <br />且同意起亚经销商与我联系。
            </span>
            </el-checkbox>
          </el-form-item>
          <el-form-item class="" style="margin-bottom: auto !important;">
            <el-button type="primary" @click="submitInformation"
              style="background-color: #000000;color: #fff;border: none;" code-ga="event, PAGEURL, 悬浮提交按钮点击"
              code-stm="event, PAGEURL, 悬浮提交按钮点击">提 交</el-button>
          </el-form-item>
        </el-form>
        <div id="captcha-element1"></div>
        <!-- 隐藏的验证码触发按钮，用于共享验证码实例 -->
        <button id="captcha-trigger-button" style="display: none;"></button>
      </div>
    <Header></Header>
    <CarListNavbar></CarListNavbar>
    <div id="kv"  class="overlay-images">
      <img class="overlay-image" src="/assets/~/media/images/activity/policy2602/pc/kv.jpg" alt=""/>
    </div>
    <div id="page1" class="overlay-images page1-image-container">
      <img class="overlay-image page1-image" src="/assets/~/media/images/activity/policy2602/pc/page-ev5.jpg" alt=""/>
    </div>
    <div id="page2" class="overlay-images page2-image-container">
      <img class="overlay-image page2-image" src="/assets/~/media/images/activity/policy2602/pc/page-ev6.jpg" alt=""/>
    </div>
    <div id="page3" class="overlay-images page3-image-container">
      <img class="overlay-image page3-image" src="/assets/~/media/images/activity/policy2602/pc/page-sportage.jpg" alt=""/>
    </div>
    <div id="page4" class="overlay-images page4-image-container">
      <img class="overlay-image page4-image" src="/assets/~/media/images/activity/policy2602/pc/page-seltos.jpg" alt=""/>
    </div>
    <div class="pc-part-container"
        style="width: 100%;">
      <img class="pc-fixed-bg" src="/assets/~/media/images/activity/policy2602/pc/bj.jpg" alt="">
      <div class="pc-part-content">
        <div id="part1">
          <Part1></Part1>
        </div>
        <div id="part2">
          <Part2></Part2>
        </div>
        <div id="part3">
          <Part3></Part3>
        </div>
      </div>
    </div>
    <div id="page5">
      <MyForm v-if="t" ref="myForm" :clientPosition="clientPosition"></MyForm>
    </div>
    <ShareBar></ShareBar>
    <Footer></Footer>
  </div>
  <K3MOB v-else></K3MOB>
</template>

<script>
import QRCode from 'qrcodejs2'
import K3MOB from "./Mob/index.vue"
import Header from "@/components/Header";
import CarListNavbar from "@/components/CarListNavbar";
import Part1 from "@/components/Part1";
import Part2 from "@/components/Part2";
import Part3 from "@/components/Part3";
// import Twopage from '@/components/Twopage';
// import Fivepage from '@/components/Fivepage'
import Footer from "@/components/Footer";
import MyForm from "@/components/My-Form";
import ShareBar from "@/components/ShareBar.vue";
import { apiUrl, pcdUrl, CSMUrl } from "@/config/base";
import { isPortraitFun,getUrlKey,throttle,debounce } from "@/utils/utils.js";
import $ from 'jquery'
export default {
  name:'index',
  components: { K3MOB,MyForm,Header,Footer,ShareBar,CarListNavbar,Part1,Part2,Part3 },
  data() {
    return {
      captcha: null,
      captchaSource: 'main', // 记录当前触发验证码的来源：'main' 或 'myform'
      t:false,
      isPortrait: isPortraitFun(),
      minip:false,
      flag:false,
      isShowCover: false, // 显示留资弹窗
      clientPosition: null,
      topImg: require("@/assets/images/top.svg"),
      showTopBtn:true,
      showBtn1:false,
      showBtn2:false,
      showBtn3:false,
      showBtn4:false,
      showBtn5:false,
      showBtn6:false,
      showBtn7:false,
      showBtn8:false,
      showBtn9:false,

      isAnimating: false,
      totalTime: 60,
      countDownContent: "获取验证码",
      countDownCanClick: true,
      clock: null,


      formInline: {
        Name: "",
        Phone: "",
        verificationCode: "",
        Province: "",
        City: "",
        DealerCode: "",
        DealerName: "",
        checked: false,
        CarSeriesCMSID:'436',
        CarSeriesName: "2025款 EV5",
        CarModelCMSID: "1407",
        CarModelName: "530 Land",
      },
      alldata: null,
      carAlldata: null,
      cascadingCities: [],
      cascadingDealers: [],
      showTopBtn: true,
      // page5Height:200,
      // page5Top:100,

    };
  },
  created() {
    var that = this
    if (!this.alldata) {
      console.log("try to fetch alldata from created");
      this.$axios.get(pcdUrl).then((res) => {
        console.log("fetched alldata from created", res.data);
        this.alldata = res.data;
        fetch(CSMUrl).then(function (response) {
          return response.json();
        }).then(function (data) {
          console.log("车型车款数据", data);
          that.carAlldata = data;
        });
      });
    }
  },
  mounted: function () {
    setTimeout(() => {this.t = true}, 2000)
    const _that = this
    if(getUrlKey("minip")){
      this.minip = true
    }
    setTimeout(() => {
      this.cutLocal()
    }, 2000)

    window.addEventListener('scroll', this.handleScroll);

    this.page5Height = document.getElementById("page5").offsetHeight
    this.page5Top= document.getElementById("page5").offsetTop
    //到达表单
    var that = this
    var formDone = false
    window.addEventListener('scroll', function() {
      if(!that.isPortrait){
        var scrollTop = (window.scrollY || document.documentElement.scrollTop);
        if (!(scrollTop < that.page5Top - that.page5Height - 200 ) && !(scrollTop > that.page5Top + 200 ) && !formDone ) {
          console.log('到达表单');
          formDone = true;
          _paq.push(['trackEvent', '滚动事件', (window.location.href).replace(/\<br\>/ig, ''), '到达表单']);
        }
      }
    })

    var nowName=''
    var doneArray = []
    window.addEventListener('scroll', function() {
      if(!that.isPortrait){
        var scrollTop = (window.scrollY || document.documentElement.scrollTop);
        var elements = [
            { id: 'page1', names: 'ev5' },
            { id: 'page2', names: 'ev6' },
            { id: 'page3', names: '2025款 狮铂拓界' },
            { id: 'page4', names: '2026款 赛图斯  ' },
            { id: 'part1', names: '智跑 & 2026款 奕跑' },
            { id: 'part2', names: '索奈 & 2026款 嘉华' },
            { id: 'part3', names: 'K3 & K5' }
        ];

        var newName = '';

        elements.forEach(function(item) {
            var element = document.getElementById(item.id);
            var height = element.offsetHeight;
            var top = element.offsetTop;

            if (scrollTop > top - 100 && scrollTop < top + height) {
                newName = item.names;
            }
        });

        if(newName !== nowName && doneArray.indexOf(newName)===-1 && newName && newName!==''){
          console.log(newName);
          doneArray.push(newName)
          _paq.push(['trackEvent', '滚动事件', (window.location.href).replace(/\<br\>/ig, ''), newName]);
          nowName=newName
        }
      }
    })
    this.$nextTick(() => {
      this.ensureCaptchaReady();
    });
  },
  methods: {
    ensureCaptchaReady() {
      this.waitForCaptchaElements()
        .then(() => {
          this.initCaptcha();
        })
        .catch((err) => {
          console.warn(err?.message || "captcha elements not ready");
        });
    },
    waitForCaptchaElements(retries = 30, interval = 100) {
      return new Promise((resolve, reject) => {
        const attempt = () => {
          const element = document.querySelector("#captcha-element1");
          const triggerButton = document.querySelector("#captcha-trigger-button");
          if (element && triggerButton) {
            resolve({ element, triggerButton });
            return;
          }
          if (retries <= 0) {
            reject(new Error("captcha elements missing"));
            return;
          }
          retries -= 1;
          window.setTimeout(attempt, interval);
        };
        attempt();
      });
    },
    initCaptcha() {
      //***验证start - 共享验证码实例
      console.log('initCaptcha shared instance');
      const element = document.querySelector("#captcha-element1");
      const triggerButton = document.querySelector("#captcha-trigger-button");
      if (!element || !triggerButton) {
        console.log('element or triggerButton is null');
        return;
      }
      var that = this;
      var preText = '';
      if (!window.location.href.includes("https://www.kia.cn")) {
        preText = 'https://uat.kia.cn'
      }else{
        preText = 'https://www.kia.cn'
      }
      let kiaLogoUrl = preText + '/assets/~/media/images/aliyuncaptcha/kia_logo.png';
      // 弹出式，使用隐藏的 button 元素来触发验证码
      window.initAliyunCaptcha({
      // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      SceneId: "nrr27cp0",
      // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
      mode: "popup",
      // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      element: "#captcha-element1",
      // 触发验证码弹窗或无痕验证的元素 - 使用隐藏的 button
      button: "#captcha-trigger-button",
      captchaLogoImg: kiaLogoUrl,
      // 验证码验证通过回调函数
      success: function (captchaVerifyParam) {
        // 入参为验签captchaVerifyParam
        // 根据触发来源调用不同的 countDown 方法
        console.log('captchaVerifyParam',captchaVerifyParam, 'source:', that.captchaSource);
        if (that.captchaSource === 'main') {
          that.countDown(captchaVerifyParam);
        } else if (that.captchaSource === 'myform') {
          // 触发 My-Form 组件的 countDown 方法
          const myFormComponent = that.$refs.myForm;
          if (myFormComponent && typeof myFormComponent.countDown === 'function') {
            myFormComponent.countDown(captchaVerifyParam);
          } else {
            console.warn('My-Form component not found or countDown method not available');
          }
        }
      },
      // 验证码验证不通过回调函数
      fail: function (result) {
        // 入参为不通过信息
        // 正常验证有效期内不需要做任何操作，验证码自动刷新，重新进行验证
        console.error(result);
      },
      // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
      getInstance: function (instance) {
        that.captcha = instance;
        // 将验证码实例挂载到 window 上，供 My-Form 组件使用
        window.sharedCaptchaInstance = instance;
      },
      // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。
      slideStyle: {
        width: 360,
        height: 40,
      },
      // ...其他参数，参考initAliyunCaptcha参数说明
      });
      //***验证 end */
    },
    // 处理验证码按钮点击事件
    handleCaptchaButtonClick(source) {
      // 记录触发来源
      this.captchaSource = source;
      // 触发隐藏的验证码按钮
      const triggerButton = document.querySelector("#captcha-trigger-button");
      if (triggerButton) {
        triggerButton.click();
      }
    },

      countDown(captchaVerifyParam) {
      if (!this.formInline.Phone) {
        this.$message.error("请填写正确的手机号");
        // 重新初始化验证码，以便用户可以再次尝试
        this.initCaptcha();
        return;
      }
      if (!/^1[3456789]\d{9}$/.test(this.formInline.Phone)) {
        this.$message.error("请填写正确的手机号");
        // 重新初始化验证码，以便用户可以再次尝试
        this.initCaptcha();
        return;
      }
      if (!this.countDownCanClick) return; //改动的是这两行代码
      this.countDownCanClick = false;
      this.countDownContent = this.totalTime + "s后重试";
      this.clock = window.setInterval(() => {
        this.totalTime--;
        this.countDownContent = this.totalTime + "s后重试";
        if (this.totalTime < 0) {
          window.clearInterval(this.clock);
          this.countDownContent = "重新发送";
          this.totalTime = 60;
          this.countDownCanClick = true; //这里重新开启
        }
      }, 1000);
      //发送验证码
      let getCodeData = {
        phoneNumbers: this.formInline.Phone,
        captchaVerifyParam: captchaVerifyParam,
      };
      this.$axios
        .post(`${apiUrl}sendMsg/cityTour/CaptchaSendVerificationCode`, getCodeData)
        .then((res) => {
          console.log("ressssssss", res);
          if (res.data.success) {
            this.$message.info("验证码发送成功，请注意查收");
          } else {
            this.$message.error(res.data.message);
          }
          // 重新初始化验证码，以便下次可以再次触发
          this.initCaptcha();
        });
    },

    read() {
      // this.$router.push({
      //   path: "/terms",
      // });
      const route = this.$router.resolve({ path: '/terms' });
      const href = route.href;
      window.open(href, '_blank');
    },
    checkboxChange(e){
      if(e == true){
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '勾选', 1]);
      }else{
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''), '取消勾选', 1]);
      }
    },
    //关闭移动端分享弹窗
    closePopup() {
      var isShow = document.getElementById("popup-mob-share");
      isShow.style.display = "none";
      var isShow1 = document.getElementById("qr-popup-mob-share"); //关闭二维码
      isShow1.style.display = "none";
    },
    toTop(){
      const _that = this
      $('html,body').animate({scrollTop:0},0)
      setTimeout(() => {_that.showTopBtn = false}, 1000)
    },
    handleScroll(){
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      this.showTopBtn = scrollTop > 0;
    },
    tosj(e) {
        const el = this.$refs[`pc-block${e}`];
        const headerHeight = 70; // 替换为您的固定头部的实际高度
        el.scrollIntoView();
        window.scrollBy(0, -headerHeight); // 减去固定头部的高度
      // }
    },
    async cutLocal() {
            let map = await this.load()
            let _this = this
            if (map.Map) {
                let funL = new map.Geolocation()
                funL.getCurrentPosition((res) => {
                    // 如果存在经纬度
                    if (res.point) {
                        var myGeo = new map.Geocoder();
                        myGeo.getLocation(new map.Point(res.point.lng, res.point.lat), function (result) {
                            const params = Object.assign({
                                lng: res.point.lng,
                                lat: res.point.lat
                            }, result.addressComponents)
                            console.log(params);
                            _this.clientPosition = params
                            _this.formInline.Province = _this.alldata.province.filter(item => item.name == params.province)[0].id
                            _this.setCity(true);
                            _this.formInline.City = _this.alldata.city[_this.formInline.Province].filter(item => item.name == params.city)[0].id
                            _this.cityChange(_this.formInline.City)
                        })
                    }
                }, (err) => {
                    console.log(err)
                })
            }
        },
    // 定位城市
    load() {
      return new Promise((resolve, reject) => {
        if (!this.BMap) {
          $.getScript('//api.map.baidu.com/api?v=2.0&ak=4ybCJ1rBffkf2PFgkvsRJuqAV9XBtnHq&callback=initialize', function (res) {
            console.log("百度",res);
            let num = 1
              let time = setInterval(() => {
                if (BMap.Map) {
                  this.BMap = true
                  resolve(BMap)
                  clearInterval(time)
                }
                num++
              }, 25)
          })
        } else {
          resolve(BMap)
        }
      })
    },
    forbid(){
      this.flag = true;
    },
    open(){
      this.flag = false;
    },
    gotoBlock(e) { // 用锚点跳转到固定的div块
      console.log(e);
      const el = this.$refs[`pc-block${e}`];
      el.scrollIntoView()
    },

    //新增分享方法 start
    shareToWeibo(){//分享微博
      //url不能带#
      const weiboShareUrl = `http://service.weibo.com/share/share.php?title=${document.title}&pic=https://www.kia.cn/assets/~/media/images/dyk/index/footer/weibo-share-link.jpg&url=${window.location.href}`;
      window.open(weiboShareUrl);
    },
    shareCopy(){//复制
      if(document.execCommand("Copy")){
        try {
          var txtEl = document.createElement('textarea');
          txtEl.value = window.location.href;
          document.body.appendChild(txtEl);
          txtEl.select(); // 选择对象
          document.execCommand("Copy"); // 执行浏览器复制命令
          txtEl.remove();

          // this.closePopup()
          const popup = document.getElementById('popup');
          setTimeout(function() {
              popup.style.display = 'flex';
              setTimeout(function() {
                  popup.style.display = 'none';
              }, 1000);
          }, 0);
        } catch(err) {
          // 复制失败
          console.log(err);
        }
      }else{
        navigator.clipboard.writeText(window.location.href).then(() => {
          // this.closePopup()
          const popup = document.getElementById('popup');
          setTimeout(function() {
              popup.style.display = 'flex';
              setTimeout(function() {
                  popup.style.display = 'none';
              }, 1000);
          }, 0);
        }).catch((err) => {
            console.log(err);
        });
      }
    },
    //end
    setProvince() {
    console.log("!@####123123123")
    this.formInline.City = "";
    this.setCity();
  },
  setCity(fromLocation = false) {
    // this.cascadingCities = this.alldata.city[this.formInline.Province];
    this.cascadingCities = [];
    this.alldata.city[this.formInline.Province].forEach((cityIter) => {
      //过滤city
      if (
        this.alldata.cityRelType[cityIter.id].includes("1") ||
        this.alldata.cityRelType[cityIter.id].includes("4")
      ) {
        this.cascadingCities.push(cityIter);
      }
    });
    if(!fromLocation){
      if(this.formInline.City){
        this.$set(this.formInline, 'City', this.formInline.City);
      }else{
        this.$set(this.formInline, 'City', this.cascadingCities[0].id);
      }
      // this.formInline.City = this.formInline.City || this.cascadingCities[0].id;
    }else{
      // #如果未找到对应城市数据(因为他没有经销商 所以alldata城市字典表中没这个城市),则默认选中第一个
      // this.formInline.City = this.cascadingCities.find((city) => city.name === this.clientPosition.city)?.id || this.cascadingCities[0].id
      if(!this.cascadingCities.find((city) => city.id === this.formInline.City)){
          // this.formInline.City = ''
          this.$set(this.formInline, 'City', '');
      }
    }
    this.cityChange(this.formInline.City);
  },
  async cityChange(cityId) {
    if (!cityId) {
          return;
    }
    let map = await this.load();
    let baiduMap = new map.Map();
    //改变经销商数据/起点
    let temp = this.alldata.dealer[cityId];
    this.cascadingDealers = [];
    temp.forEach((origin) => {
      //if (origin.type == "1" || origin.type == "7") {
      if (origin.type == "1" ) {
        const originPosition = new BMap.Point(
          origin.latitude,
          origin.longitude
        );
        const nowPosition = new BMap.Point(
          this.clientPosition.lng,
          this.clientPosition.lat
        );
        this.cascadingDealers.push({
          ...origin,
          distance: this.getMapDistance(
            nowPosition,
            originPosition,
            baiduMap
          ),
          isDisabled: origin.isException === "是",
        });
      }
    });
    this.cascadingDealers = this.cascadingDealers.sort((a, b) => {
      // 首先处理 isException 的情况
      if (a.isException === "是" && b.isException !== "是") {
        return 1; // a 排在 b 后面
      } else if (a.isException !== "是" && b.isException === "是") {
        return -1; // b 排在 a 后面
      }
      return a.distance - b.distance;
    });
    // if (this.cascadingDealers.length) {
    //   this.formInline.DealerCode = this.cascadingDealers[0].code;
    //   this.formInline.DealerName = this.cascadingDealers[0].name;
    // }
    if (this.cascadingDealers.length) {
      this.$set(this.formInline, 'DealerCode', this.cascadingDealers[0].code);
      this.$set(this.formInline, 'DealerName', this.cascadingDealers[0].name);
    }
  },

  setCarSeries() {
    this.formInline.CarModelCMSID = "";
    console.log(
      "this.formInline.CarSeriesCMSID",
      this.formInline.CarSeriesCMSID
    );
    if (this.formInline.CarSeriesCMSID) {
      // this.formInline.CarModelCMSID = this.carAlldata.model[this.formInline.CarSeriesCMSID].at(-1).cmsid;
      this.formInline.CarModelCMSID = this.carAlldata.model[this.formInline.CarSeriesCMSID][this.carAlldata.model[this.formInline.CarSeriesCMSID].length - 1].cmsid;
      // this.formInline.CarModelName = this.carAlldata.model[this.formInline.CarSeriesCMSID].at(-1).name;
      this.formInline.CarModelName = this.carAlldata.model[this.formInline.CarSeriesCMSID][this.carAlldata.model[this.formInline.CarSeriesCMSID].length - 1].name
    }
    console.log('this.formInline.CarModelName', this.formInline.CarModelName);
  },
  getMapDistance(centerPoint, otherPoint, map) {
    let distance = map.getDistance(centerPoint, otherPoint);
    return (distance / 1000).toFixed(2);
  },
  dealerChange(dealerCode) {
    let dealer = this.cascadingDealers.find((value) => {
      return value.code === dealerCode;
    });
    this.formInline.DealerCode =
      dealer == null ? this.cascadingDealers[0].code : dealer.code;
    this.formInline.DealerName =
      dealer == null ? this.cascadingDealers[0].name : dealer.name;
  },
  submitInformation() {
    console.log(this.formInline);
    if (
      !this.formInline.Name ||
      !this.formInline.Phone ||
      !this.formInline.verificationCode ||
      !this.formInline.CarSeriesCMSID
    ) {
      this.$message.error("请完善信息后再次提交");
      return;
    }
    if (!/^1[3456789]\d{9}$/.test(this.formInline.Phone)) {
        this.$message.error("请填写正确的手机号");
        return;
      }
    //获取车型名字
    // console.log(this.carSeries)
    let CarSeriesName = this.carAlldata.series.find((item, index) => {
      return item.cmsid === this.formInline.CarSeriesCMSID;
    });
    //获取默认经销商名字和编码
    if (!this.formInline.DealerCode || !this.formInline.DealerName) {
      this.formInline.DealerCode = this.cascadingDealers[0].code;
      this.formInline.DealerName = this.cascadingDealers[0].name;
    }
    //将省市转化成字符串
    let provinceStr = this.alldata.province.find(
      (item) => item.id === this.formInline.Province
    );
    let cityStr = this.alldata.city[this.formInline.Province].find(
      (item) => item.id === this.formInline.City
    );
    provinceStr = provinceStr.name;
    cityStr = cityStr.name;

    if (!this.formInline.checked) {
      this.$message.error("请先同意已阅读并同意《隐私协议》，且同意起亚经销商与我联系");
      return;
    }

    let currentYear= new Date().getFullYear();
    let  currentMonth = new Date().getMonth() + 1;
    let activename  = "2026年2月政策专题页预约试驾";
    let subFormDrive = {
      //媒体来源、活动来源、媒体渠道ID没写
      CarBuyingTime: "-",
      carModelCmsid: this.formInline.CarModelCMSID,
      carModelName: this.formInline.CarModelName,
      carSeriesCmsid: this.formInline.CarSeriesCMSID,
      carSeriesName: CarSeriesName.name,
      cityName: cityStr,
      dealerCode: this.formInline.DealerCode,
      dealerName: this.formInline.DealerName,
      provinceName: provinceStr,
      userName: this.formInline.Name,
      userPhone: this.formInline.Phone,
      verificationCode: this.formInline.verificationCode,
      smartCode: getUrlKey("utm_source") || "官网", //媒体来源
      activity: activename, //活动名称
      extraSix: getUrlKey("utm_soid") || "76",
    };
    //预约试驾接口
    this.$axios
        .post(`${apiUrl}clue/newkiaAaustralia/saveClue`, subFormDrive)
        .then((res) => {
      console.log(99999998888, res);
      if (res.data.success) {
        this.$message.success("预约试驾成功");
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),
              '活动留资线索提交成功', JSON.stringify(subFormDrive)]);
        console.log(subFormDrive);
        setTimeout(() => {
          this.formInline.CarModelCMSID = "";
          this.formInline.CarSeriesCMSID = "";
          this.formInline.DealerCode = "";
          this.formInline.DealerName = "";
          this.formInline.Name = "";
          this.formInline.Phone = "";
          this.formInline.verificationCode = "";
          this.formInline.City = "";
          this.formInline.Province = "";
          this.formInline.checked = false;
          // 重置倒计时
          window.clearInterval(this.clock);
          this.countDownContent = "获取验证码";
          this.totalTime = 60;
          this.countDownCanClick = true;
        }, 1000);
      } else {
        this.$message.error("预约试驾失败:" + res.data.message);
        _paq.push(['trackEvent', '点击事件', (window.location.href).replace(/\<br\>/ig, ''),
              '活动留资线索提交失败', JSON.stringify(subFormDrive)]);
        console.log(subFormDrive);
        console.log(res.msg);
      }

    });
  },
  },

}

</script>

<style lang="scss" scoped>
// .pc-img {
//   width:100vw;
//   height: calc(1620 / 2880 * 100vw);
// }
.pc-part-container {
  position: relative;
  z-index: 0;
  display: grid;
}
.pc-part-content {
  grid-area: 1 / 1;
  position: relative;
  z-index: 1;
}
.pc-fixed-bg {
  grid-area: 1 / 1;
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: -1;
  display: block;
  align-self: start;
  object-fit: cover;
  object-position: bottom center;
}
.overlay-images {
  position: relative;
  height: calc(1222 / 2200 * 100vw); /* 根据需要调整高度 */
}
.page1-image-container {
  height: calc(1004 / 1920 * 100vw);
}
.page2-image-container {
  height: calc(951 / 1920 * 100vw);
}
.page3-image-container {
  height: calc(973 / 1920 * 100vw);
}
.page4-image-container {
  height: calc(991 / 1920 * 100vw);
}
.overlay-image {
  position: absolute;
  top: 0;
  left: 0;
  width:100vw;

  /* 确保图片完整显示 */
}
.page1-image {
  height: calc(1004 / 1920 * 100vw);
}
.page2-image {
  height: calc(951 / 1920 * 100vw);
}
.page3-image {
  height: calc(973 / 1920 * 100vw);
}
.page4-image {
  height: calc(991 / 1920 * 100vw);
}
.select-option-dealer .el-select-dropdown__item {
  height: auto !important;
  padding: 0 10px;
}
.el-select-dropdown__item.selected {
    font-weight: 500 !important;
  }
.nobtn{
  background: #00000000;
  border: none;
}
.btn-box {
    width: 7.9166vw;
    height: 2.9166vw;
    position: absolute;
    left: 11.3vw;
    top: 30vw!important;
    z-index: 10;
    /* justify-content: flex-end; */
    /* .text {
      width:100%;
      height:auto;
      opacity: 0;
      transition: all 0.3s linear;
      &-show {
        opacity: 1;
      }
    } */
    .btn-go {
      border: 1px solid #fff;
	    width: 7.9166vw;
      height: 2.9166vw;
      // opacity: 0;
      transition: all 0.3s linear;
      background: rgba(0,0,0,0);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 0.8333vw;
      color: #fff;
      cursor: pointer;
      &-show {
        opacity: 1;
      }
      /* &:hover {
        color: #bb152b;
      } */
    }
  }
.right-btn-box{
  position: fixed;
  right: 10px;
  bottom: 120px;
  z-index: 100;
  img{
    width: 44px;
    height: 44px;
  }
}
.fullPage {
  padding: 0;
  margin: 0;
  height: calc(100vh);
  overflow: hidden;
  background-color: #fff;
  color: #000000;
}
.fullPageContainer {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  transition: all ease-out 0.8s;
}
.section {
  width: 100%;
  height: calc(100vh);
  background-position: center center;
  background-repeat: no-repeat;
  transform: translate3d(0,0,0);
}
.section5{
  height: auto;
  background: #1f1f1f;
  &-portrait {
    height: 100vh;
  }
}

.cover {
  width: 100%;
  height: 90vh;
  position: fixed;
  z-index: 9;
  top: 100vh;
  left: 0;
  transition: all 0.6s ease;
  overflow: auto;
  background: rgba($color: #000000, $alpha: 0.8);
  &-show {
    top: 10vh;
  }
}
.cover2 {
  width: 100%;
  height: 100vh;
  background: rgba($color: #000000, $alpha: 0.7);
  position: fixed;
  z-index: 8;
  top: 0;
  left: 0;
}
.section2{
  height:unset;
}
.btnnnn{
  width: calc(268 / 1920 * 100vw);
  height: calc(60 / 1920 * 100vw);
  cursor: pointer;
}
.btn-xg{
  cursor: pointer;

  .line-xg{
    height: 2px;
    background-image: linear-gradient(to right, #000000, #66666600);
  }
  // &:hover{
    .line-xg{
      animation: line-ani 2s linear infinite;
    }
    img{
      animation: icon-ani 2s linear infinite;
      // animation-duration: 0.5s;
      // animation-delay: 1s;
      // animation-fill-mode: forwards;
      // animation-iteration-count: infinite
    }
  // }
}
@keyframes line-ani {
  0% {
    width: 0%;
  }
  40% {
    width: 100%;
  }
  100% {
    width: 100%;
  }
}
@keyframes icon-ani {
  0% {
    transform: scale(1)
  }
  40%{
    transform: scale(1)
  }
  50% {
    transform: scale(1.3)
  }
  60%{
    transform: scale(1)
  }
  100% {
    transform: scale(1)
  }
}
/* 新增 css start */
.popup { /* 复制成功*/
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 120px;
    height: 120px;
    background-color: #05141F;
    opacity: 0.8;
    border-radius: 10px;
    /* display: flex; */
    display: none;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    z-index: 1000000;
    font-size: 16px;
    color: #ffffff;
  }
  .popup img {
    width: 40px;
    height: 40px;
    margin-bottom: 5px;
  }

  /* mob分享弹窗 */
  .popup-mob-share { /* 复制成功*/
    position: fixed;
    left: 50%;
    top: 50%;
    width: 70%;
    transform: translate(-50%, -50%);
    background-color: #05141F;
    opacity: 0.9;
    border-radius: 10px;
    /* display: flex; */
    display: none;
    justify-content: space-between;
    align-items: center;
    z-index: 1000000;
    font-size: 16px;
    padding: 40px 30px 30px 30px;
  }
  .popup-mob-share .popup-mob-share-img {
    width: 50px;
    height: 65px;
    margin-bottom: 5px;
  }
  .qr-popup-mob-share{
    width: 120px;
    height: 120px;
    border-radius: 10px;
    background-color: #ffffff;
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -100px;
    right: calc(100% - 115px);
    transition: all .5s;
  }
  .qr-popup-mob-share::after {
    content: "";
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: -5px; /* 使三角形垂直居中 */
    border-width: 5px;
    border-style: solid;
    border-color: #f9f9f9 transparent transparent transparent;
}
.qr-popup-mob-share .qr-code-wx {
      width: 91px;
      height: 91px;
      /* margin-bottom: 10px; */
  }

  .my-button {
    background: url('https://www.kia.cn/assets/~/media/images/dyk/index/footer/guanbi.png') no-repeat;
    background-size: cover;
    right:-10px;
    top:-10px;
    width:24px;
    height:24px;
    position:absolute;
  }
  .a-share-wx:hover .qr-code-box-wx {
    display: flex;
  }
  .qr-code-box-wx {
    width: 120px;
    height: 120px;
    border-radius: 10px;
    background-color: #ffffff;
    /* display: flex; */
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0px;
    right: 168px;
    transition: all .5s;
  }
  .qr-code-box-wx::after {
    content: "";
    position: absolute;
    top: 40px;
    right: -10px; /* 调整三角形位置 */
    margin-top: -5px; /* 使三角形垂直居中 */
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent transparent #f9f9f9; /* 通过调整颜色来隐藏或显示三角形 */
}

  .qr-code-box-wx .qr-code-wx {
      width: 91px;
      height: 91px;
      /* margin-bottom: 10px; */
  }

  .qr-code-box-wx .text-wx {
      font-size: 12px;
      color: #05141F;
      line-height: 16px;
      width: 100px;
      text-align: center;
  }
  @media (min-width: 768px) {
    .btn-book {
    background: url("https://uat.kia.cn/assets/~/media/images/dyk/index/app_icon.png")
      no-repeat;
    background-size: 100%;
    // position: fixed;
    // bottom: calc(6vh + 300px);
    // right: 8px;
    width: 44px;
    height: 44px;
    cursor: pointer;
    overflow: hidden;
    z-index: 999;
  }

  .qr-code-box {
    width: 104px;
    height: 167px;
    background: url("https://uat.kia.cn/assets/~/media/images/dyk/index/app_icon_bg.png")
      no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -180px;
    right: -23.3rem;
    transition: all 0.5s;
  }

  .qr-code-box .qr-code {
    width: 91px;
    height: 91px;
    margin-bottom: 10px;
  }

  .qr-code-box .text {
    font-size: 12px;
    color: #05141f;
    line-height: 16px;
    width: 100px;
    text-align: center;
  }

  .btn-book:hover {
    overflow: visible;
  }

  .btn-book:hover .qr-code-box {
    right: 2px;
  }
  // 预约试驾
  .go_testdrive_new {
    // position: fixed;
    // bottom: 296px;
    width: 44px;
    height: 44px;
    cursor: pointer;
    overflow: hidden;
    // z-index: 999;
    // right: 10px;
    img {
      width: 100%;
      height: 100%;
    }
  }
  // 问卷调查
  /* 调查问卷 start */
  .btn-survey {
    // position: fixed;
    // bottom: 240px;
    // right: 10px;
    z-index: 1001;
    width: 44px;
    height: 44px;
    background: url("https://uat.kia.cn/assets/~/media/images/dyk/sidebar-icon/survey.png")
      no-repeat;
    background-size: 100% 100%;
    transition: all 0.3s;
    overflow: hidden;
    cursor: pointer;
  }

  #survey-popup {
    position: fixed;
    bottom: calc(6vh + 240px);
    right: 8px;
    z-index: 10000;
    width: calc(0 / 1920 * 100vw);
    height: calc(0 / 1920 * 100vw);
    background-image: url("https://uat.kia.cn/assets/~/media/images/survey/popup.png");
    background-size: 100% 100%;
    /* box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1); */
    border-radius: 0.8px;
    transform: translate(0, 0) scale(0);
    transition: 1s ease-in-out;

    /* transition: transform 1s ease-in-out; */
  }

  .survey-popup-content {
    height: 100%;
  }

  .survey-popup-title {
    font-family: "KiaSignatureRegular", "方正兰亭", "Helvetica Neue", Helvetica,
      Arial, sans-serif;
    color: #000000;
    width: 40%;
    height: calc(0 / 1920 * 100vw);
    /* font-family: 'FZLanTingHeiS-B-GB'; */
    font-size: calc(0 / 1920 * 100vw);
    display: flex;
    align-items: flex-end;
    justify-content: center;
    transition: 1s ease-in-out;
  }

  .survey-popup-text {
    font-family: "KiaSignatureRegular", "方正兰亭", "Helvetica Neue", Helvetica,
      Arial, sans-serif;
    color: #000000;
    height: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: calc(0 / 1920 * 100vw);
    transition: 1s ease-in-out;
  }

  .survey-popup-btns {
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .survey-popup-btn {
    /* width: 30%;
            height: 20px; */
    padding: calc(0 / 1920 * 100vw) calc(0 / 1920 * 100vw);
    background: #000;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: 1s ease-in-out;
  }

  #survey-popup.active {
    position: fixed;
    bottom: 50%;
    right: 50%;
    width: calc(500 / 1920 * 100vw);
    height: calc(290 / 1920 * 100vw);
    z-index: 10000;
    transform: translate(50%, 50%) scale(1);
  }

  #survey-popup.active .survey-popup-content {
    height: 100%;
  }

  #survey-popup.active .survey-popup-title {
    height: calc(70 / 1920 * 100vw);
    /* font-family: 'FZLanTingHeiS-B-GB'; */
    font-size: calc(28 / 1920 * 100vw);
  }

  #survey-popup.active .survey-popup-text {
    font-size: calc(22 / 1920 * 100vw);
  }

  #survey-popup.active .survey-popup-btns .survey-popup-btn {
    /* width: 30%;
            height: 20px; */
    padding: calc(10 / 1920 * 100vw) calc(50 / 1920 * 100vw);
  }

  /* 调查问卷 end */
  .btn-share {
    background: url("https://www.kia.cn/assets/~/media/images/dyk/index/footer/share-threepoint.png")
      no-repeat;
    background-size: 100%;
    // position: fixed;
    // bottom: 180px;
    // right: 10px;
    width: 45px;
    height: 45px;
    cursor: pointer;
    overflow: visible;
    z-index: 9;
  }
  .btn-share:hover .dropdown-content {
    /* overflow: visible; */
    display: flex;
  }
  .btn-share:hover .little-triangle {
    display: block;
  }
  .btn-share-pc {
    display: block;
  }

  .btn-share-mob {
    display: none;
  }
  .dropdown-content {
    border-radius: 10px;
    min-width: 140px;
    background-color: #ffffff;
    // display: flex;
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 86px;
    right: 54px;
    transition: all 0.5s;
    padding: 15px 0;
  }
  .dropdown-content::after {
    content: "";
    position: absolute;
    /* top: 50%; */
    right: -10px;
    margin-top: -5px;
    width: 10px;
    /* border-width: 5px;
    border-style: solid;
    border-color: transparent transparent transparent #f9f9f9; */
    padding: 90px 0px;
  }
  .little-triangle {
    display: none;
    position: absolute;
    top: 70%;
    right: 44px;
    margin-top: -5px;
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent transparent #f9f9f9;
  }
  .dropdown-item {
    min-width: 160px;
    font-size: 16px;
    font-weight: 400;
    display: flex;
    align-items: center;
    padding: 15px 25px 15px 25px;
  }
  .dropdown-item:hover {
    color: #bb162b;
  }
  .dropdown-item-text {
    padding-left: 10px;
  }
  .btn-book {
    background: url("https://uat.kia.cn/assets/~/media/images/dyk/index/app_icon.png")
      no-repeat;
    background-size: 100%;
    // position: fixed;
    // bottom: calc(6vh + 300px);
    // right: 8px;
    width: 44px;
    height: 44px;
    cursor: pointer;
    overflow: hidden;
    z-index: 999;
  }

  .qr-code-box {
    width: 104px;
    height: 167px;
    background: url("https://uat.kia.cn/assets/~/media/images/dyk/index/app_icon_bg.png")
      no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -180px;
    right: -23.3rem;
    transition: all 0.5s;
  }

  .qr-code-box .qr-code {
    width: 91px;
    height: 91px;
    margin-bottom: 10px;
  }

  .qr-code-box .text {
    font-size: 12px;
    color: #05141f;
    line-height: 16px;
    width: 100px;
    text-align: center;
  }

  .btn-book:hover {
    overflow: visible;
  }

  .btn-book:hover .qr-code-box {
    right: 2px;
  }
}
.m-b-19 {
  margin-bottom: 8px;
}



  /* 新增 css end */
  .oneform {
  background-color: #ffffff;
  text-align: center;
  padding-top: 10px;
  width: 100%;
  position: fixed;
  bottom: 0;
  z-index: 100;
}

.animate {
  animation: heightAni 1s ease-in-out forwards;
  /* 假设动画持续 3 秒钟 */
}

// ::v-deep .el-input__inner {
//   background-color: #FFFFFF00;
//   border-radius: unset;
//   color: #fff;

//   &::placeholder {
//     color: #FFFFFF80;
//   }
// }
.tips {
    font-size: calc(16 / 2200 * 100vw);
    // color: #FFFFFF99;
    // text-align: left;
    // display: flex;
}
.inbox {
  width: calc(198 / 1920 * 100vw);
  margin-bottom: 10px;
}
.inboxinput > ::v-deep.el-input__inner{
  background-color: #EEEEEE ;
  border-radius: unset;
  color: #000000;

  &::placeholder {
    color: grey ;
  }
}

.inboxinput > ::v-deep.el-input> .el-input__inner{
  background-color: #EEEEEE ;
  border-radius: unset;
  color: #000000;

  &::placeholder {
    color: grey;
  }
}
::v-deep .el-checkbox__inner {
  background: transparent;
  border: 1px solid rgba($color: #19191C, $alpha: 0.3);
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #19191C;
  border-color: #19191C;
}
::v-deep .el-input-group__append {
  border-radius: 0;
}
.disabled {
  color: #a7a7a7 !important;
}
</style>
